import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './Screens/Login.tsx';
import DashboardScreen from './Screens/DashboardScreen.tsx';
import InfluenceersScreen from './Screens/InfluenceersScreen.tsx';
import PrivateRoute from './PrivateRoute.tsx';
import InfluencerDetailScreen from './Screens/InfluencerDetailScreen.tsx';
import AdminScreen from './Screens/AdminScreen.tsx';


function App() {
  return (
    <Router>
      <Routes>
        {/* Default Login */}
        <Route path="/" element={<Login />} />

        {/* Protected Routes */}
        <Route
          path="/Dashboard"
          element={
            <PrivateRoute>
              <DashboardScreen />
            </PrivateRoute>
          }
        />

        <Route
          path="/Influencers"
          element={
            <PrivateRoute>
              <InfluenceersScreen />
            </PrivateRoute>
          }
        />
       <Route path="/influencer-detail/:id" element={<InfluencerDetailScreen />} />
       <Route path="/AdminScreen" element={<AdminScreen />} />
      </Routes>
    </Router>
  );
}

export default App;
